const serviceAreas = [
  { city: '台中', desc: '設計總部・全方位服務' },
  { city: '台北', desc: '北部服務據點' },
  { city: '台南', desc: '南部服務據點' },
  { city: '高雄', desc: '南部服務據點' },
];

const whyConsult = [
  {
    icon: 'ri-shield-check-line',
    title: '免費初步諮詢',
    desc: '首次諮詢完全免費，了解需求後才進行報價，無任何隱藏費用。',
  },
  {
    icon: 'ri-time-line',
    title: '24小時內回覆',
    desc: '收到諮詢申請後，我們承諾在 24 小時內主動聯繫確認時間。',
  },
  {
    icon: 'ri-user-heart-line',
    title: '專屬顧問服務',
    desc: '每個案子都有專屬設計顧問，從第一次聯繫到完工全程陪伴。',
  },
  {
    icon: 'ri-file-text-line',
    title: '透明報價流程',
    desc: '報價明細清楚，不含模糊項目，讓你在預算內做出最佳決策。',
  },
];

export default function ContactInfo() {
  return (
    <div className="flex flex-col gap-8">
      {/* Why Consult */}
      <div className="bg-[#1a1a1a] rounded-2xl p-7 md:p-8">
        <h3 className="font-bold text-white mb-6" style={{ fontSize: '1.125rem' }}>
          為什麼選擇心旅商研？
        </h3>
        <div className="flex flex-col gap-5">
          {whyConsult.map((item) => (
            <div key={item.title} className="flex items-start gap-4">
              <div className="w-10 h-10 flex items-center justify-center bg-[#b8956a]/15 rounded-xl flex-shrink-0">
                <i className={`${item.icon} text-[#b8956a] text-base`}></i>
              </div>
              <div>
                <p className="font-medium text-white text-sm mb-1">{item.title}</p>
                <p className="text-white/55 text-xs leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Contact Details */}
      <div className="bg-[#f4f2ef] rounded-2xl p-7 md:p-8">
        <h3 className="font-bold text-[#1a1a1a] mb-6" style={{ fontSize: '1.125rem' }}>
          聯絡資訊
        </h3>
        <div className="flex flex-col gap-5">
          {[
            { icon: 'ri-phone-line', label: '電話', value: '04-2202-3211', href: 'tel:0422023211' },
            { icon: 'ri-mail-line', label: 'Email', value: 'newplusdesign2017@gmail.com', href: 'mailto:newplusdesign2017@gmail.com' },
            { icon: 'ri-chat-1-line', label: 'LINE ID', value: '@xinlvdesign', href: '#' },
            { icon: 'ri-instagram-line', label: 'Instagram', value: '@xinlv.design', href: '#' },
            { icon: 'ri-map-pin-line', label: '台中總部', value: '台中市北區中清路一段79號6樓-C', href: 'https://maps.google.com/?q=台中市北區中清路一段79號6樓-C' },
          ].map((c) => (
            <a
              key={c.label}
              href={c.href}
              className="flex items-center gap-4 group cursor-pointer"
            >
              <div className="w-9 h-9 flex items-center justify-center bg-white border border-[#e2ddd8] rounded-lg flex-shrink-0">
                <i className={`${c.icon} text-[#b8956a] text-sm`}></i>
              </div>
              <div>
                <p className="text-[#8a8a8a] text-xs">{c.label}</p>
                <p className="text-[#1a1a1a] text-sm font-medium group-hover:text-[#b8956a] transition-colors">
                  {c.value}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>

      {/* Service Areas */}
      <div className="bg-[#fafaf8] border border-[#e2ddd8] rounded-2xl p-7 md:p-8">
        <h3 className="font-bold text-[#1a1a1a] mb-5" style={{ fontSize: '1.125rem' }}>
          可服務區域
        </h3>
        <div className="grid grid-cols-2 gap-3">
          {serviceAreas.map((area) => (
            <div key={area.city} className="flex items-center gap-3 p-3 bg-[#f4f2ef] rounded-xl">
              <div className="w-8 h-8 flex items-center justify-center bg-[#b8956a] rounded-lg flex-shrink-0">
                <i className="ri-map-pin-2-line text-white text-sm"></i>
              </div>
              <div>
                <p className="text-[#1a1a1a] font-semibold text-sm">{area.city}</p>
                <p className="text-[#8a8a8a] text-xs">{area.desc}</p>
              </div>
            </div>
          ))}
        </div>
        <p className="text-[#8a8a8a] text-xs mt-4 leading-relaxed">
          全台各縣市均可提供服務，特殊地區請來電洽詢差旅說明。
        </p>
      </div>

      {/* Office Hours */}
      <div className="bg-[#fafaf8] border border-[#e2ddd8] rounded-2xl p-7 md:p-8">
        <h3 className="font-bold text-[#1a1a1a] mb-5" style={{ fontSize: '1.125rem' }}>
          服務時間
        </h3>
        <div className="flex flex-col gap-3">
          {[
            { day: '週一 ─ 週五', time: '10:00 – 19:00' },
            { day: '週六', time: '10:00 – 17:00（預約制）' },
            { day: '週日 / 國定假日', time: '休息（LINE 留言可）' },
          ].map((h) => (
            <div key={h.day} className="flex items-center justify-between">
              <span className="text-[#5a5a5a] text-sm">{h.day}</span>
              <span className="text-[#1a1a1a] text-sm font-medium">{h.time}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
